//import { writable } from 'svelte/store';

function createCoinPosition() {

    const position = { deltaX: 0, deltaY: 0, isSaved: false }



    function save(deltaX, deltaY) {

        position.deltaX = deltaX
        position.deltaY = deltaY
        position.isSaved = true
    }

    function clear() {
        position.isSaved = false
    }

    function isSaved() {
        return position.isSaved
    }


    function getPos() {

        return { deltaX: position.deltaX, deltaY: position.deltaY }
    }

    return { getPos, save, isSaved, clear }
}


export const coinPosition = createCoinPosition()
